import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["cancel", "closeButton"];
  connect() {
    // Ensures modal reopens after closing it, then clicking browser back button
    if (this.element.classList.contains("modal-exit") && this.element.open) {
      this.element.removeAttribute("open");
    }

    if (!this.element.open) {
      this.element.showModal();
    }
    this.element.addEventListener("close", (e) => {
      this.close();
    });
    const modalInput = document.getElementsByName("redirect_to")[0];
    if (modalInput) {
      modalInput.value = window.location.toString();
    }
    const close = (target) => {
      target.addEventListener("click", (e) => {
        this.close();
      });
    };
    this.cancelTargets.forEach(close);
    this.closeButtonTargets.forEach(close);
    const failSafeUrl = this.element.getAttribute("data-fail-safe-return-url");
    if (failSafeUrl) {
      this.element.addEventListener("close", (e) => {
        if (window.location.pathname != failSafeUrl) {
          Turbo.visit(failSafeUrl);
        }
      });
    }
  }

  close() {
    const url = new URL(window.location.href);
    if (url.searchParams.has("m")) {
      url.searchParams.delete("m");
      Turbo.visit(url.toString());
    } else {
      this.element.close();
    }
  }

  disconnect() {
    this.element.remove();
  }
}
